import builder from '../builder';
import PlantFlowers from '../../streamline-icons/bold/plant-flowers.svg';

export default builder('IconPlantFlowersBold', PlantFlowers);
